<template>
  <button
    class="btn mr-xxs mb-xs"
    :class="{ active: isActive }"
    @click="filterClick"
  >
    <slot></slot>
  </button>
</template>

<script setup>
import { computed, toRefs } from "vue";

const props = defineProps({
  category: String, // Button category
  selectedCategory: String, // Currently selected category
});

const emit = defineEmits(["update:filter"]);

const { category, selectedCategory } = toRefs(props);

const isActive = computed(() => selectedCategory.value === category.value);

const filterClick = () => {
  emit("update:filter", category.value);
};
</script>

<style scoped lang="scss">
.btn {
  display: inline-block;
  padding: 1em 1.75em;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 550;
  transition: all 0.3s ease-in-out;
  background-color: transparent;
  color: $text--col;
  border: 2px solid $btn--border;
  white-space: nowrap;
  width: fit-content;
  @media (max-width: 768px) {
    &:hover {
      background-color: $brand--col--dark;
    }
  }
  &.active {
    background-color: $brand--col;
  }
}
</style>
